<template>
  <div class="warranty-apply">
    <!-- 申请延保 -->
  </div>
</template>
